import type { ReactElement } from "react";
import { usersRegisteredFixture } from "./fixtures";
import type { MetricGranularity } from "./fixtures";
import { GrowthChart } from "./GrowthChart";

export interface UsersRegisteredChartProps {
  /** Granularity selected by the screen's shared `PeriodSelector`. */
  readonly granularity: MetricGranularity;
}

/**
 * New-users-registered-per-period growth chart (ISSUE-352 rescoping, T3),
 * channel-split (mobile vs. Telegram), fixture-backed via
 * `usersRegisteredFixture`. Takes `granularity` as a prop rather than owning
 * a `PeriodSelector` itself — the screen assembly step wires one shared
 * selector to both T3 charts (Implementation Plan step 3).
 */
export function UsersRegisteredChart({ granularity }: UsersRegisteredChartProps): ReactElement {
  return (
    <GrowthChart
      title="New users registered"
      granularity={granularity}
      envelope={usersRegisteredFixture[granularity]}
      isFixture
    />
  );
}
